var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioDm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.042,
    viewBox: "0 0 40 48.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_372",
    "data-name": "Groupe 372",
    transform: "translate(-61.429 -222.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_506",
    "data-name": "Groupe 506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_503",
    "data-name": "Groupe 503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_576",
    "data-name": "Trac\\xE9 576",
    d: "M95.429,270.236h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.436.059,14.748,0,17.6-.028,3.556-.038,3.623-.039,4.274.612.408.407,5.136,6.359,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623v25.279A6.007,6.007,0,0,1,95.429,270.236Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V239.53C95.97,237.49,89,228.7,86.937,226.192c-.461,0-1.112.008-1.853.016C82.22,226.239,76.889,226.295,67.424,226.236Z",
    fill: "#973eff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_507",
    "data-name": "Groupe 507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_552",
    "data-name": "Trac\\xE9 552",
    d: "M89.184,243.1c.5,0,.789.546.789.989l.116,11.027a.906.906,0,0,1-1.8,0L88.133,243.9C88.133,243.454,88.685,243.1,89.184,243.1Z",
    fill: "#973eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_18",
    "data-name": "Soustraction 18",
    d: "M86.444,251.6a3.645,3.645,0,1,1-3.645,3.645h0A3.646,3.646,0,0,1,86.444,251.6Z",
    fill: "#973eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_554",
    "data-name": "Trac\\xE9 554",
    d: "M89.964,241.764v2.963c.027.5-.34.728-.839.754l-11.923.625a.9.9,0,0,1-.946-.852l0-2.77a.752.752,0,0,1,.594-.882.816.816,0,0,1,.12-.014l11.923-.625A.985.985,0,0,1,89.964,241.764Z",
    fill: "#973eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_553",
    "data-name": "Trac\\xE9 553",
    d: "M77.08,242.191a.9.9,0,0,1,.9.9h0V257.57a.9.9,0,1,1-1.809,0l.092-14.873C76.263,242.2,76.585,242.191,77.08,242.191Z",
    fill: "#973eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_19",
    "data-name": "Soustraction 19",
    d: "M74.346,253.925A3.645,3.645,0,1,1,70.7,257.57a3.646,3.646,0,0,1,3.646-3.645Z",
    fill: "#973eff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDm);
export default __webpack_public_path__ + "static/media/audioDM.f93be365df1f029d53b3d2135a8f530a.svg";
export { ForwardRef as ReactComponent };